/**
 * API path constants for the certificate-management service.
 * Base path matches the Serverless Framework `basePath` (`loopay-certificate-management`).
 */
const certificateEndpoints = {
  LIST: 'loopay-certificate-management/certificates',
  EXPORT: 'loopay-certificate-management/certificates/export',
  FACILITIES: 'loopay-certificate-management/certificates/facilities',
  EQUIPMENT: 'loopay-certificate-management/certificates/equipments',
  VIEW: (id: string) => `loopay-certificate-management/certificates/${id}`,
  DOWNLOAD: (id: string) =>
    `loopay-certificate-management/certificates/${id}/download`,
} as const;

export default certificateEndpoints;
